module.exports = __webpack_public_path__ + "static/media/roundedrect-tertiary-wide.ee3726ef.png";